// Brand colors for tech icons. Most brand colors read fine on both light and
// dark surfaces; near-black brands live in ADAPTIVE with a per-mode value so
// they stay visible in dark mode. Names with no entry fall back to the theme
// color (kept neutral), so generic concepts don't get arbitrary colors.
const COLORS = {
  JavaScript: "#f7df1e",
  TypeScript: "#3178c6",
  Java: "#f89820",
  Python: "#3776ab",
  "C++": "#00599c",
  SQL: "#e38c00",
  HTML5: "#e34f26",
  HTML: "#e34f26",
  CSS3: "#1572b6",
  CSS: "#1572b6",

  React: "#61dafb",
  "React 18": "#61dafb",
  ReactJS: "#61dafb",
  "React Flow": "#ff0072",
  Redux: "#764abc",
  ReduxJS: "#764abc",
  "Tailwind CSS": "#06b6d4",
  Bootstrap: "#7952b3",
  MUI: "#007fff",

  "Node.js": "#339933",
  NodeJS: "#339933",
  "Spring Boot": "#6db33f",
  SpringBoot: "#6db33f",
  Spring: "#6db33f",
  FastAPI: "#009688",
  Sequelize: "#52b0e7",
  GraphQL: "#e10098",

  PostgreSQL: "#4169e1",
  MongoDB: "#47a248",
  MySQL: "#4479a1",
  Couchbase: "#ea2328",
  Redis: "#ff4438",

  AWS: "#ff9900",
  "AWS S3": "#569a31",
  Azure: "#0078d4",
  "Azure AD SSO": "#0078d4",
  Docker: "#2496ed",
  Podman: "#892ca0",
  Jenkins: "#d24939",
  "GitLab CI/CD": "#fc6d26",
  "GitHub Actions": "#2088ff",
  OpenShift: "#ee0000",
  Kubernetes: "#326ce5",
  nginx: "#009639",
  Netlify: "#00c7b7",

  Git: "#f05032",
  Linux: "#fcc624",
  "VS Code": "#007acc",
  "IntelliJ IDEA": "#fe315d",
  PyCharm: "#21d789",
  Postman: "#ff6c37",

  OpenCV: "#5c3ee8",
  ESP32: "#e7352c",
  "Raspberry Pi": "#a22846",
  Arduino: "#00979d",
  "Machine Learning": "#ff6f00",

  Swagger: "#85ea2d",
  Stripe: "#635bff",
  Razorpay: "#3395ff",
  Framer: "#0055ff",
  Webhooks: "#3b82f6",
};

// Near-black brands: invisible on dark backgrounds, so pick per mode.
const ADAPTIVE = {
  "Next.js": { light: "#111111", dark: "#e6e6e6" },
  "Express.js": { light: "#111111", dark: "#e6e6e6" },
  ExpressJS: { light: "#111111", dark: "#e6e6e6" },
  Flask: { light: "#111111", dark: "#e6e6e6" },
  Vercel: { light: "#111111", dark: "#e6e6e6" },
  GitHub: { light: "#181717", dark: "#e6e6e6" },
  Prisma: { light: "#2d3748", dark: "#b9c2d0" },
  Kafka: { light: "#111111", dark: "#e6e6e6" },
  "Apache Kafka": { light: "#111111", dark: "#e6e6e6" },
  IFTTT: { light: "#111111", dark: "#e6e6e6" },
  "OAuth / JWT": { light: "#111111", dark: "#e6e6e6" },
  DBeaver: { light: "#382923", dark: "#c9a98f" },
};

export const getBrandColor = (name, mode = "dark") => {
  if (ADAPTIVE[name]) return ADAPTIVE[name][mode] || ADAPTIVE[name].dark;
  return COLORS[name] || null;
};

export default getBrandColor;
